import React from 'react';
import { oneOf, node, object, string, oneOfType } from 'prop-types';
import setClass from '../../common/set-class';
import Icon from '../icon';
export const formatClass = (theme, kind) => {
    const kinds = {
        slim: 'b-kandji-banner--slim',
        normal: '',
        block: 'b-kandji-banner--block',
    };
    const themes = {
        error: '--error',
        warning: '--warning',
        success: '--success',
        info: '--info',
        'success-strong': '--success-strong',
        'info-strong': '--info-strong',
    };
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (themes[theme]) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        return `${themes[theme]}${kind ? ` ${kinds[kind]}` : ''}`;
    }
    return 'b-kandji-banner b-kandji-banner--success';
};
export const setIcon = (theme, customIcon) => {
    if (typeof customIcon === 'string' && customIcon.length > 0) {
        return customIcon;
    }
    const classes = {
        error: 'circle-xmark',
        warning: 'triangle-exclamation',
        info: 'triangle-exclamation',
        success: 'circle-check',
        'info-strong': 'triangle-exclamation',
        'success-strong': 'circle-check',
    };
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const icon = classes[theme];
    if (icon) {
        return icon;
    }
    return classes.success;
};
const Banner = (props) => {
    const { theme, children, kind, style, icon, className, src } = props;
    const child = React.Children.only(children);
    const cloned = React.cloneElement(child, {
        className: setClass([
            'b-txt',
            'b-kandji-banner__txt',
            child.props.className || '',
        ]),
        style: child.props.style,
    });
    const bannerClassName = setClass([
        'b-kandji-banner',
        `b-kandji-banner${formatClass(theme, kind)}`,
        className,
    ]);
    return (React.createElement("div", { className: bannerClassName, style: style },
        src ? (React.createElement("img", { src: src, alt: `${theme} icon` })) : (React.createElement(Icon, { name: setIcon(theme, icon), className: "b-kandji-banner__icon" })),
        cloned));
};
Banner.propTypes = {
    theme: oneOf([
        'error',
        'warning',
        'success',
        'success-strong',
        'info',
        'info-strong',
    ]),
    /** expects one child only to be used as the text for the banner next to the icon. You can pass in a span, p, etc, but stick to `<p>` tags. If for some reason you need to override stuff, you can pass extra class or style to the child tag as well. */
    children: node,
    kind: oneOf(['slim', 'normal', 'block']),
    style: object,
    icon: string,
    className: string,
    src: oneOfType([string, node]),
};
Banner.defaultProps = {
    children: React.createElement("p", null),
    theme: 'success',
    kind: 'normal',
    style: {},
    icon: '',
    className: null,
    src: null,
};
export default Banner;
